import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/site";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="rounded-2xl bg-primary-500 px-8 py-12 text-center md:px-16 md:py-16">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            {t("ctaSection.title")}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-background-50/90">
            {t("ctaSection.subtitle")}
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 cursor-pointer transition-colors"
          >
            {t("ctaSection.button")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}